import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './pages/components/Header';
import Footer from './components/Footer';

export default function PublicLayout(): React.ReactElement {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Header />
            {/* Main content is rendered here. Added padding to compensate for the fixed header. */}
            <main style={{ flexGrow: 1, paddingTop: 80 }}>
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}